<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">gavel</v-icon>
			<v-toolbar-title>Dane formalno-prawne</v-toolbar-title>
		</v-toolbar>
		<v-btn v-if="editable && roles.isAdministrator()" class="mt-3 ml-3" color="primary" dark
			@click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>

		<div v-if="!roles.isAdministrator()" class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Forma prawna</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.legalForm"
						aria-label="label for legal form">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer NIP</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.nip"
						aria-label="label for nip">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer KRS</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.krs"
						aria-label="label for krs">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="!hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Nazwa rejestru identyfikującego podmiot</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.evidenceType"
						aria-label="label for evidence type">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="!hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer w rejestrze</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.evidenceNumber"
						aria-label="label for evidence number">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>

		<div v-else class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Forma prawna</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-select
						data-vv-name="legalForm"
						data-vv-as="Forma prawna"
						:error-messages="vErrors.collect('formalDataScope.legalForm')"
						:readonly="readOnlyMode"
						:items="legalForms"
						v-model="data.legalForm"
						v-validate="'required'"
						data-vv-scope="formalDataScope"
						aria-label="legal form">
					</v-select>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer NIP</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="nip"
						data-vv-as="Numer NIP"
						:error-messages="vErrors.collect('formalDataScope.nip')"
						:readonly="readOnlyMode"
						v-model="data.nip"
						data-vv-validate-on="none"
						v-validate="'required|digits:10'"
						data-vv-scope="formalDataScope"
						aria-label="label for nip">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer KRS</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="krs"
						data-vv-as="Numer KRS"
						:error-messages="vErrors.collect('formalDataScope.krs')"
						:readonly="readOnlyMode"
						v-model="data.krs"
						v-validate="'required|numeric'"
						data-vv-scope="formalDataScope"
						aria-label="label for krs">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="!hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Nazwa rejestru identyfikującego podmiot</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						v-model="data.evidenceType"
						aria-label="label for evidence type">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row v-if="!hasKrs">
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Numer w rejestrze</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						v-model="data.evidenceNumber"
						aria-label="label for evidence number">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>

	</v-card-text>
</template>

<script>
	import {getDictionary} from "../../../../../utils/LegalFormDictionary";

	export default {
		name: "FormalProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},

				legalForms: [],
			};
		},

		watch: {
			formalData: function () {
				this.data = this.formalData;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("formalDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			},
		},

		computed: {
			hasKrs() {
        return this.data.krs;
			},

			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		created() {
			this.legalForms = Object.values(getDictionary());
		},

		props: {
			formalData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>
